import {Banner} from '@wandb/components';
import React from 'react';

import {MAX_REPORT_IMPORT_PANELS} from './utils';

export const ReportImportPanelLimitBanner = () => (
  <Banner mt={3} mb={6} variant="warning" isDismissible={false}>
    Only the first {MAX_REPORT_IMPORT_PANELS.toLocaleString()} panels will be
    added to the report.
  </Banner>
);
